import SidePanelLayout from "aldoo-ra/SidePanel"
import MediaLibraryContent from "aldoo-ra/MediaLibrary/media-library-content"
import MediaLibraryStats from "./media-library-stats"

function MediaLibraryPage() {
  return (
    <div className="flex flex-col h-screen">
      <MediaLibraryContent title="Media Library" />
    </div>
  )
}

export default function AdminMediaLibrary() {
  return (
    <SidePanelLayout
      menuName="AdminMediaLibrary"
      tabs={{
        "media-library": MediaLibraryPage,
        "stats": MediaLibraryStats,
      }}
    />
  )
}
